import React, { PureComponent } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Formik, Field } from 'formik';
import FormSectionContainer from '@client/containers/formSectionContainer/FormSectionContainer';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import InputGroup from '@client/components/formComponents/inputGroup/InputGroup';
import styles from './formContactPreferences.scss';

function Checkbox({ field, type, className }) {
  return (
    <div>
      {/* remove {...field} to see changes not propagated */}
      <input {...field} type={type} className={className ? className : ''} />
      <label>{field.name}</label>
    </div>
  );
}

class FormContactPreferences extends PureComponent {
  showPreferencesFormSection = () => {
    const { userInfo } = this.props;
    const contactByEmail = true;
    const contactByPhone = false;

    //mock data, dont know at the moment how this should be....

    return contactByEmail || contactByPhone;
  };

  render() {
    const { className, formProps, translations } = this.props;

    const formValues = formProps.values;
    const formErrors = formProps.errors;
    return (
      <form
        onSubmit={formProps.handleSubmit}
        className={`${styles.formContactPreferences}${
          className ? ` ${className}` : ''
        }`}
      >
        {this.showPreferencesFormSection && (
          <FormSectionContainer
            className={styles.formSectionContainerProp}
            title={'KONTAKTPREFERENSER'}
          >
            <div className={styles.subTitle}>
              Här kan du uppdatera dina kontaktpreferenser.
            </div>
            <div className={styleHelper.flexRow}>
              <Field
                name="Send me tips and support for my fundraiser"
                type="checkbox"
                component={Checkbox}
                className={styles.checkbox}
              />
            </div>
            <div className={`${styleHelper.flexRow} ${styles.buttonContainer}`}>
              <button
                className={`${styleHelper.btnPrimaryMd} ${styles.button}`}
              >
                Uppdatera
              </button>
            </div>
          </FormSectionContainer>
        )}
      </form>
    );
  }
}

FormContactPreferences.propTypes = {
  userInfo: ImmutablePropTypes.map,
};
export default FormContactPreferences;
